module.exports = __webpack_public_path__ + "templates.checkout-object-detail-aa00c8d1.html";